import { render } from "./whr-project-dynamic.vue?vue&type=template&id=3dc2530e&scoped=true"
import script from "./whr-project-dynamic.vue?vue&type=script&lang=js"
export * from "./whr-project-dynamic.vue?vue&type=script&lang=js"

import "./whr-project-dynamic.vue?vue&type=style&index=0&id=3dc2530e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dc2530e"]])

export default __exports__